import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {ImagingToolEvent} from '../models/imaging-tool.event';

@Component({
  selector: 'app-tdo-imaging-contextmenu',
  templateUrl: './tdo-imaging-contextmenu.component.html',
  styleUrls: ['./tdo-imaging-contextmenu.component.scss']
})
export class TdoImagingContextmenuComponent implements OnInit {

  @Input() x = 0;
  @Input() y = 0;
  @Input() isRuler = false;
  @Output() imagingContextMenuEvent = new EventEmitter<any>();

  constructor() {
  }

  ngOnInit(): void {
  }

  onContextMenuDelete(value: string) {
    console.log('context menu', value);
    this.imagingContextMenuEvent.emit(value);
  }
}
